(function () {
  "use strict";
  var root = document.getElementById("rvaCat");
  if (!root || !root.classList.contains("rva-style-page")) return;
  var panel = document.getElementById("panel");
  if (!panel) return;

  var TABS = [["desc", "Description"], ["specs", "Specs"], ["price", "Pricing"], ["ship", "Shipping"]];
  var OPTS = { childList: true, subtree: true, characterData: true };
  var tab = "desc", busy = false, queued = false, obs = null;
  var MQ = window.matchMedia ? window.matchMedia("(max-width: 899px)") : null;

  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }
  function money(n) {
    return typeof window.money === "function" ? window.money(n) : "$" + n.toFixed(2);
  }
  function current() {
    var S = window.S;
    if (!S || typeof window.styleById !== "function") return null;
    return window.styleById(S.open);
  }
  function setHTML(node, html) {
    if (node.getAttribute("data-h") !== html) {
      node.innerHTML = html;
      node.setAttribute("data-h", html);
    }
  }

  function info(right, st) {
    var box = right.querySelector(".pPriceBox");
    if (!box || !box.parentNode) return;
    var line = right.querySelector(".ssInfo") || el("div", "ssInfo");
    line.style.order = "1";
    setHTML(line, "<span>Sizes: <b>" + esc(st.sizes || "") + "</b></span>" +
      '<button type="button" class="ssLink" data-ss-go="desc">View description</button>');
    if (box.nextSibling !== line) box.parentNode.insertBefore(line, box.nextSibling);
  }

  function colors(right, st, color) {
    var cg = right.querySelector("#cg");
    var sect = cg && cg.closest(".sect");
    if (!sect) return;
    sect.classList.add("ssColors");
    var head = sect.querySelector(".ssCHead") || el("p", "ssCHead");
    setHTML(head, "<b>" + st.c.length + " colors</b> · Selected color: <b>" + esc(color ? color[0] : "") + "</b>");
    if (cg.previousElementSibling !== head) sect.insertBefore(head, cg);
  }

  function controls(right) {
    var q = right.querySelector("#pQtyEdit");
    var meta = right.querySelector(".pMeta");
    if (q && meta && q.parentNode !== meta) meta.appendChild(q);
  }

  function photoFor(color) {
    var u = "";
    try { u = typeof window.frontURL === "function" ? window.frontURL(color) : ""; } catch (e) { u = ""; }
    if (!u) {
      var big = panel.querySelector(".pTile img.phBig");
      u = big ? big.getAttribute("src") || "" : "";
    }
    return u;
  }

  function sizes(right, st, color) {
    var grid = right.querySelector(".sizeGrid");
    if (!grid) return;
    var sect = grid.closest(".sect");
    if (sect) sect.classList.add("ssSizes");
    var cells = Array.prototype.filter.call(grid.children, function (c) { return c.classList.contains("sz"); });
    grid.style.setProperty("--ssN", String(cells.length));

    var col = grid.querySelector(":scope > .ssCol");
    if (!col) { col = el("div", "ssCol"); grid.insertBefore(col, grid.firstChild); }
    var url = color ? photoFor(color) : "";
    var chip = color && typeof window.chipStyle === "function" ? window.chipStyle(color) : "";
    var sw = url
      ? '<img src="' + esc(url) + '" alt="" loading="lazy" decoding="async" onerror="this.outerHTML=\'<span class=&quot;ssChip&quot; style=&quot;' + esc(chip) + '&quot;></span>\'">'
      : '<span class="ssChip" style="' + esc(chip) + '"></span>';
    setHTML(col, '<span class="ssHd">Color</span><span class="ssSw">' + sw + "<b>" + esc(color ? color[0] : "") + "</b></span>");

    var lb = grid.querySelector(":scope > .ssLbls");
    if (!lb) { lb = el("div", "ssLbls", "<span></span><span>Price</span><span>Qty</span>"); }
    if (col.nextSibling !== lb) grid.insertBefore(lb, col.nextSibling);

    var priceEl = right.querySelector(".pPrice");
    var base = priceEl ? parseFloat(String(priceEl.textContent).replace(/[^0-9.]/g, "")) : NaN;
    var SIZES = window.SIZES || [];
    cells.forEach(function (sz) {
      var inp = sz.querySelector("input");
      if (!inp) return;
      var z = inp.getAttribute("data-z");
      var up = 0;
      try { up = typeof window.upOf === "function" ? +window.upOf(st, SIZES.indexOf(z)) || 0 : 0; } catch (e) { up = 0; }
      var p = sz.querySelector(".ssP");
      if (!p) { p = el("span", "ssP"); }
      if (p.nextSibling !== inp) sz.insertBefore(p, inp);
      var txt = isFinite(base) ? money(base + up) : "";
      if (p.textContent !== txt) p.textContent = txt;
      if (p.classList.contains("ssUp") !== up > 0) p.classList.toggle("ssUp", up > 0);
      if (!inp.getAttribute("aria-label")) inp.setAttribute("aria-label", z + " quantity");
    });
  }

  function tabs(right) {
    var box = right.querySelector(".rvaDetails");
    if (!box) return;
    var have = {};
    var specs = box.querySelector(".pSpecs");
    if (specs) { specs.setAttribute("data-ss", "desc"); have.desc = specs; }
    Array.prototype.forEach.call(box.querySelectorAll("details"), function (d) {
      var s = d.querySelector("summary");
      var t = s ? s.textContent : "";
      var k = d.classList.contains("rvaShip") ? "ship" : /size chart/i.test(t) ? "specs" : /price/i.test(t) ? "price" : "";
      if (!k) return;
      d.setAttribute("data-ss", k);
      if (!d.open) d.open = true;
      have[k] = d;
    });
    var list = TABS.filter(function (t) { return have[t[0]]; });
    if (!list.length) return;
    if (!have[tab]) tab = list[0][0];
    box.classList.add("ssTabbed");
    var bar = box.querySelector(".ssTabs");
    if (!bar) {
      bar = el("div", "ssTabs");
      bar.setAttribute("role", "tablist");
      bar.setAttribute("aria-label", "Product information");
    }
    setHTML(bar, list.map(function (t) {
      return '<button type="button" class="ssTab" role="tab" data-ss-tab="' + t[0] + '" aria-selected="' + (t[0] === tab) + '">' + t[1] + "</button>";
    }).join(""));
    var h2 = box.querySelector(":scope > h2");
    var after = h2 ? h2.nextSibling : box.firstChild;
    if (bar.parentNode !== box || (h2 ? h2.nextSibling !== bar : box.firstChild !== bar)) box.insertBefore(bar, after);
    list.forEach(function (t) {
      var node = have[t[0]];
      var on = t[0] === tab;
      if (node.classList.contains("ssOn") !== on) node.classList.toggle("ssOn", on);
    });
  }

  function links(left, right, st) {
    var ul = panel.querySelector(".ssLinks") || el("ul", "ssLinks");
    var box = right.querySelector(".rvaDetails");
    var hasSpecs = !!(box && box.querySelector('[data-ss="specs"]'));
    var all = document.querySelector(".rvaMore .rvaAllBrand");
    var html = (hasSpecs ? '<li class="ssJump"><button type="button" data-ss-go="specs">Size chart</button></li>' : "") +
      '<li class="ssJump"><button type="button" data-ss-go="price">Price by quantity</button></li>' +
      '<li class="ssCopy"></li>' +
      (all ? '<li><a href="' + esc(all.getAttribute("href")) + '">' + esc(all.textContent.replace(/\s*→\s*$/, "")) + "</a></li>" : "");
    setHTML(ul, html);
    var copy = panel.querySelector("#copyProdLink");
    var slot = ul.querySelector(".ssCopy");
    if (copy && slot && copy.parentNode !== slot) {
      if (/copy a link/i.test(copy.textContent)) copy.textContent = "Copy a link to this product";
      slot.appendChild(copy);
    }
    if (!copy && slot) slot.parentNode.removeChild(slot);
    var after = MQ && MQ.matches ? (right.querySelector(".rvaTrust") || right.querySelector(".addRow")) : null;
    if (after && after.parentNode === right) {
      if (after.nextSibling !== ul) right.insertBefore(ul, after.nextSibling);
    } else if (ul.parentNode !== left || left.lastElementChild !== ul) left.appendChild(ul);
  }

  function smThumbs(left, color) {
    var tile = left.querySelector(".pTile");
    var main = tile && tile.querySelector("img.phBig");
    var old = left.querySelector(".ssThumbs");
    var bk = color && typeof window.rvaFlatBack === "function" ? window.rvaFlatBack(color) : "";
    if (left.querySelector(".rvaThumbs") || !main || !bk || !/sanmar/.test(String(color[3] || ""))) {
      if (old && old.parentNode) old.parentNode.removeChild(old);
      return;
    }
    var key = color[3] + "|" + bk;
    if (old && old.getAttribute("data-k") === key && old.previousElementSibling === tile) return;
    if (old && old.parentNode) old.parentNode.removeChild(old);
    var box = el("div", "ssThumbs");
    box.setAttribute("data-k", key);
    [[color[3], "Front"], [bk, "Back"]].forEach(function (v, i) {
      var b = el("button", i === 0 ? "on" : "");
      b.type = "button";
      b.setAttribute("aria-label", v[1] + " photo");
      b.setAttribute("data-src", v[0]);
      b.innerHTML = '<img src="' + esc(v[0]) + '" alt="" loading="lazy" decoding="async">';
      box.appendChild(b);
    });
    tile.parentNode.insertBefore(box, tile.nextSibling);
  }

  function apply() {
    var st = current();
    var left = panel.querySelector(".pLeft");
    var right = panel.querySelector(".pRight");
    if (!st || !left || !right) return;
    var color = typeof window.swatchOf === "function" ? window.swatchOf(st) : null;
    info(right, st);
    colors(right, st, color);
    controls(right);
    sizes(right, st, color);
    tabs(right);
    smThumbs(left, color);
    links(left, right, st);
  }

  function run() {
    queued = false;
    if (busy) return;
    busy = true;
    if (obs) obs.disconnect();
    try { apply(); } catch (e) {   }
    if (obs) obs.observe(panel, OPTS);
    busy = false;
  }
  function schedule() {
    if (queued) return;
    queued = true;

    if (window.Promise) Promise.resolve().then(run); else setTimeout(run, 0);
  }

  function go(k) {
    tab = k;
    run();
    var bar = panel.querySelector(".ssTabs");
    if (!bar) return;
    var top = bar.getBoundingClientRect().top + window.pageYOffset - 110;
    try { window.scrollTo({ top: top, behavior: "smooth" }); } catch (e) { window.scrollTo(0, top); }
  }

  panel.addEventListener("click", function (e) {
    var t = e.target.closest("[data-ss-tab]");
    if (t) { tab = t.getAttribute("data-ss-tab"); run(); return; }
    var g = e.target.closest("[data-ss-go]");
    if (g) { e.preventDefault(); go(g.getAttribute("data-ss-go")); return; }
    var th = e.target.closest(".ssThumbs button");
    if (th) {
      var main = panel.querySelector(".pTile img.phBig");
      if (main) main.src = th.getAttribute("data-src");
      Array.prototype.forEach.call(th.parentNode.children, function (b) { b.classList.toggle("on", b === th); });
    }
  });
  panel.addEventListener("keydown", function (e) {
    var t = e.target.closest("[data-ss-tab]");
    if (!t || (e.key !== "ArrowRight" && e.key !== "ArrowLeft")) return;
    var all = Array.prototype.slice.call(t.parentNode.children);
    var i = all.indexOf(t) + (e.key === "ArrowRight" ? 1 : -1);
    var next = all[(i + all.length) % all.length];
    if (next) { tab = next.getAttribute("data-ss-tab"); run(); var n = panel.querySelector('[data-ss-tab="' + tab + '"]'); if (n) n.focus(); }
  });

  if (window.MutationObserver) {
    obs = new MutationObserver(schedule);
    obs.observe(panel, OPTS);
  }
  if (MQ) {
    if (MQ.addEventListener) MQ.addEventListener("change", schedule);
    else if (MQ.addListener) MQ.addListener(schedule);
  }
  schedule();
  var tries = 0;
  var iv = setInterval(function () {
    tries++;
    if (panel.querySelector(".pRight")) schedule();
    if (tries > 40) clearInterval(iv);
  }, 250);
})();